import React from 'react';

import {
    Row,
    Col,
    Divider,
    Select
} from 'antd';

import {
    _getEezeePaymentDetails
} from '../../services'
import {
    MKT_BASE_CURRENCY
} from "../../index"

const { Option } = Select;

class EezeePaymentDetails extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            eezeePaymentDetails: []
        }
    }

    render() {
        return (
            <Row>
                <Row style={{ marginTop: 16 }}>
                    <Col>
                        <Divider />
                        <h2>Eezee Payment Details</h2>

                    </Col>
                </Row>
                <Row gutter={8}>
                    <Col span={8}>
                        <div>
                            <h4>{MKT_BASE_CURRENCY}</h4>
                            {this.renderPaymentDetailSelect(MKT_BASE_CURRENCY)}
                            {this.renderEnterprisePaymentDetails(MKT_BASE_CURRENCY)}
                        </div>
                    </Col>
                </Row>
            </Row>
        )
    }

    componentDidMount() {
        _getEezeePaymentDetails()
        .then(_data => {
            this.setState({
                eezeePaymentDetails: _data.data
            })
        })
    }

    renderPaymentDetailSelect = (mktBaseCurrency) => {

        const { eezeePaymentDetails } = this.state

        let currencyPaymentDetails = eezeePaymentDetails.filter(_paymentDetails => _paymentDetails.mktBaseCurrency == mktBaseCurrency )
        let enterprisePaymentDetails = this.props.enterprise.eezeePaymentDetails
        let value = ( enterprisePaymentDetails && enterprisePaymentDetails[mktBaseCurrency] ) ? enterprisePaymentDetails[mktBaseCurrency] : `${mktBaseCurrency}-default`

        return (
            <Select value={value} style={{ width: 240 }} onChange={(e) => this.onPaymentDetailsChange(mktBaseCurrency, e)}>
                {currencyPaymentDetails.map(_paymentDetails => {
                    return (
                        <Option value={_paymentDetails.name}>{_paymentDetails.name}</Option>
                    )
                })}
            </Select>
        )

    }

    renderEnterprisePaymentDetails = (mktBaseCurrency) => {

        const { eezeePaymentDetails } = this.state

        let enterprisePaymentDetails = this.props.enterprise.eezeePaymentDetails
        let enterprisePaymentDetailsName = ( enterprisePaymentDetails && enterprisePaymentDetails[mktBaseCurrency] ) ? enterprisePaymentDetails[mktBaseCurrency] : `${mktBaseCurrency}-default`
        let paymentDetails = eezeePaymentDetails.filter(_paymentDetail => _paymentDetail.name == enterprisePaymentDetailsName)[0]

        if (!paymentDetails) { return }

        return (
            <div style={{marginTop: 8}}>
                <div>Bank Name: <b>{paymentDetails.bankName}</b></div>
                <div>Account Number: <b>{paymentDetails.accountNumber}</b></div>
                <div>Bank Code / Branch Code: <b>{paymentDetails.bankCode}</b></div>
                <div>Swift Code: <b>{paymentDetails.swiftCode}</b></div>
                <br/>
                <div>Remarks: <br/><br/>
                {paymentDetails.remarks || "-"}</div>
            </div>
        )
    }

    onPaymentDetailsChange = (mktBaseCurrency, e) => {
        this.props.onPaymentDetailsChange(mktBaseCurrency, e)
    }

}

export default EezeePaymentDetails



// WEBPACK FOOTER //
// ./src/components/enterprise/profile-eezee-payment-details.js